"use client";

import { useEffect } from "react";

export default function GlobalError({ error }) {
  useEffect(() => {
    if (error) {
      console.error("[GlobalError]", error);
    }
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
          <div className="max-w-md text-center space-y-4 px-6">
            <h2 className="text-2xl font-semibold">Something went wrong.</h2>
            <p className="text-sm text-muted-foreground">
              Please try again in a moment.
            </p>
          </div>
        </div>
      </body>
    </html>
  );
}
